import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Calendar from 'src/components/lib/Calendar/index.vue';
import { calendarDefaults } from 'src/consts/calendar';
import {
  onMounted,
  watch,
  reactive,
  computed,
} from 'vue';
import { dtFormat, ensureDate } from 'src/lib/dateHelper';

interface MyCalenderState {
  isDateValueSet: boolean;
  dateValue: Date | null;
}

// withDefaultsでdefaultを与えても、TS上optional(?)でないとrequired:trueのままになるVueの仕様
// https://github.com/vuejs/core/blob/v3.5.35/packages/compiler-sfc/src/script/resolveType.ts (required: !e.optional)
// defaultを持つ以下のpropsは全てoptionalにしている
interface Props {
  dateValue?: Date;
  format?: string;
  inputClassObj?: Record<string, string>;
  inputClearButton?: boolean;
  clearButton2Disabled?: boolean;
  readonly?: boolean;
  placeholder?: string;
  lang?: string;
  pane?: number;
  dayHeaderFormat?: string;
  disableSwitchMonthView?: boolean;
  onDayClick?: (date: Date, dateString: string) => void;
  changePane?: (year: number, month: number, pane: number) => void;
  dateInputBgColor?: string;
  setDateValueOnce?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MyCalendar',
  props: {
    dateValue: {},
    format: { default: calendarDefaults.format },
    inputClassObj: { default: () => ({}) },
    inputClearButton: { type: Boolean, default: calendarDefaults.inputClearButton },
    clearButton2Disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: calendarDefaults.readonly },
    placeholder: {},
    lang: { default: calendarDefaults.lang },
    pane: { default: calendarDefaults.pane },
    dayHeaderFormat: { default: calendarDefaults.dayHeaderFormat },
    disableSwitchMonthView: { type: Boolean, default: calendarDefaults.disableSwitchMonthView },
    onDayClick: { type: Function, default: () => () => { } },
    changePane: { type: Function, default: () => () => { } },
    dateInputBgColor: {},
    setDateValueOnce: { type: Boolean, default: true }
  },
  emits: ['date-input', 'keyup'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = reactive<MyCalenderState>({
  isDateValueSet: false,
  dateValue: props.dateValue ?? null,
});

const trySetDateValue = () => {
  if (!props.dateValue) return;
  if (props.setDateValueOnce && state.isDateValueSet) return;

  state.isDateValueSet = true;
  state.dateValue = props.dateValue;
};
onMounted(trySetDateValue);

watch(() => props.dateValue, trySetDateValue);

const inputValue = computed<string>({
  get: () => {
    if (!state.dateValue) return '';

    return dtFormat(new Date(state.dateValue), props.format);
  },
  set: (val: string) => {
    let dt = ensureDate(val);
    if (dt && (val && val.length === props.format.length)) {
      // 桁数が正常かつdtが正常なら、その時点で同期しておく
      state.dateValue = dt;
    }
    emit('date-input', dt);
  },
});

const onKeyup = ($event: KeyboardEvent) => {
  emit('keyup', $event);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Calendar, _mergeProps({
    modelValue: inputValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event))
  }, _ctx.$props, { onKeyup: onKeyup }), null, 16, ["modelValue"]))
}
}

})